<template>
 <div class="grid-content">
    <div class="loading" v-loading="isLoading">
      <el-form
        label-position="left"
      >
        <el-row
          v-for="(item, index) in dataList"
          :key="index"
        >
          <el-col :span="8">
            <el-form-item
              label=""
            >
              <span>{{item.GroupName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="8">
            <el-form-item
              label="是否SproutVideo视频"
            >
              <el-checkbox v-model="item.IsSproutVideo" size="small" class="input-width" :disabled="isReadonly">
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <hr />
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row v-if="!isReadonly" class="cs-filter-row">
      <el-col :span="4" class="footer-left">
        <el-button
          size="medium"
          :disabled="submitBtnDisable"
          type="primary"
          @click="onSave"
          >保存</el-button
        >
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert
          :closable="false"
          v-show="showError"
          v-bind:title="errorMessage"
          type="error"
          show-icon
        ></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUniversityGroupSettings, saveUniversityGroupSettings  } from "../../service/common.service";

export default {
  props: {
    isReadonly: Boolean
  },
  data() {
    return {
      isLoading : false,
      dataList:[],
      submitBtnDisable: false,
      showError: false,
      errorMessage: ""
    };
  },
  components: {
   
  },
  created() {
    this.isLoading = true;
    getUniversityGroupSettings().then(result =>{
      if (!!result && result.success){
        this.dataList = result.data;
      }else{
        this.$message.error(result.message);
      }
      this.isLoading = false;
    }).catch(()=>{
      this.isLoading = false;
    });
  },
  methods: {
    onSave(){
      this.submitBtnDisable = true;
      saveUniversityGroupSettings(this.dataList).then(result =>{
        if (!!result && result.success){
          this.$message.success("保存成功");
        }else{
          this.$message.error(result.message);
        }
        this.submitBtnDisable = false;
      }).catch(()=>{
        this.submitBtnDisable = false;
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/universityManagement/universityGroupSetting.vue